import { Flex, type FlexProps, Grid } from '@vimeo/bokeh';

export interface ClipPageBaseProps extends FlexProps {
  isSideBySideActive?: boolean;
  gridTemplateAreas?: string;
  isShowcaseLayout?: boolean;
  showcaseConfig?: {
    isShowcaseClipView?: boolean;
    isShowcaseEmpty?: boolean;
    isShowcaseMobilePreview?: boolean;
  };
}

/**
 * Creates the page background and sets up the grid and max width for content
 * Grid layout is different depending on theatre mode
 */
export const ClipPageBase = ({
  children,
  gridTemplateAreas,
  isSideBySideActive = false,
  isShowcaseLayout = false,
  showcaseConfig,
  ...rest
}: ClipPageBaseProps) => {
  const { isShowcaseEmpty, isShowcaseMobilePreview = false } = showcaseConfig || {};
  return (
    <Flex
      backgroundColor="background"
      flex="1"
      direction="column"
      align="center"
      position="relative" // to absolutely position player relative to this container
      {...rest}
    >
      <Grid
        flex={isShowcaseEmpty ? '1' : undefined}
        w="100%"
        maxW="1536px"
        gridTemplateColumns={{ base: 'minmax(0, 1fr)', md: 'repeat(6, minmax(0, 1fr))' }}
        gridAutoRows={isShowcaseEmpty ? undefined : 'max-content'}
        gridTemplateAreas={gridTemplateAreas}
        gap={{ base: 200, md: 200, lg: 300 }}
        pt={isSideBySideActive && !isShowcaseLayout ? { base: 0, md: 200, lg: 300 } : 0}
        pb={{ base: 200, lg: 300 }}
        px={isShowcaseMobilePreview ? 0 : { base: 0, md: 200, lg: 300 }}
      >
        {children}
      </Grid>
    </Flex>
  );
};
